const textAnim = $(".text-anim-title");

if (textAnim) {
    textAnim.each(function () {
        const _this = $(this);
        const textArr = _this.html().split(" ");
        _this.text("");

        textArr.forEach(function (letter) {
            const span = document.createElement("span");
            const span_inner = document.createElement("span");
            $(span).addClass("split-anim");
            $(span_inner).addClass("split-anim__inner");
            if (letter == "<br>") {
                const br = document.createElement("br");
                _this.append(br);
            } else {
                span_inner.textContent = letter;
                span.append(span_inner);
                _this.append(span);

                const empt = document.createElement("span");
                $(empt).text(" ");
                _this.append(empt);
            }

            // $(span).css("height", span.offsetHeight + (span.offsetHeight / 10) + "px");
            // $(span).css("paddingTop", span.offsetHeight + (span.offsetHeight / 10) + "px");
        })
    })
}
// $(window).resize(function() {
//     if (textAnim) {
//         textAnim.each(function () {
//             let span = $(this).find(".split-anim");
//             span.removeAttr("style");
//         });
//     }
// });
